import type { OnChanges, SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DepositMethodApi } from 'api-typings/payments/payments';

@Component({
  standalone: false,
  selector: 'app-payment-method-icon',
  template: `
    <fl-picture
      class="PaymentMethod-icon mr-small"
      [boundedWidth]="true"
      [src]="imageSrc"
    ></fl-picture>
  `,
  styleUrls: ['./payment-method-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentMethodIconComponent implements OnChanges {
  imageSrc = 'payments/cc_placeholder.svg';

  @Input() type: DepositMethodApi;

  ngOnChanges(changes: SimpleChanges): void {
    if ('type' in changes) {
      switch (this.type) {
        case DepositMethodApi.TEAM_BILLING:
          this.imageSrc = 'payments/team_billing.svg';
          break;

        case DepositMethodApi.ENTERPRISE_BILLING:
          this.imageSrc = 'payments/enterprise_billing.svg';
          break;

        case DepositMethodApi.PAYPAL_REFERENCE:
          this.imageSrc = 'payments/paypal.svg';
          break;

        case DepositMethodApi.APPLEPAY_REFERENCE:
          this.imageSrc = 'payments/applepay.svg';
          break;

        default:
          this.imageSrc = 'payments/cc_placeholder.svg';
      }
    }
  }
}
